import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

// initial state
const state: gnb.state.GnbState = {
    languageFields: undefined,
    timeFields: undefined,
    cardState: "NONE",
    userCard: null,
    companyCards: [],
    settings: {
        mySetting: {
            mySetting: {
                personCode: "",
                tabOrder: "0,1,2",
                language: "ko",
                isReceiveApproveMail: false,
                isReceiveNextMail: false,
                isReceiveBeforeMail: false,
                isReceiveAfterMail: false,
                isReceiveRefMail: false,
                isReceiveCompleteMail: false,
                isReceiveCompleteApproveMail: false,
                isTUReceiveApproveMail: false,
                isTUReceiveNextMail: false,
                isTUReceiveBeforeMail: false,
                isTUReceiveAfterMail: false,
                isTUReceiveRefMail: false,
                isTUReceiveCompleteMail: false,
                isTUReceiveCompleteApproveMail: false,
                fiDocumentCount: 10,
                createdId: "",
                createdDate: new Date(),
                isRead: true,
                isCreated: false,
                isUpdate: false,
                isDelete: false,
                actionType: "Read",
                isRefApmCompleteMail: false,
                isRefApmReceiptMail: false,
                isRefApmRejectMail: false,
                isTURefApmCompleteMail: false,
                isTURefApmReceiptMail: false,
                isTURefApmRejectMail: false,
                isReceiveCommentMail: false,
                isTUReceiveCommentMail: false,
            },
        },
        delegate: {
            delegationList: [],
        },
        applicationList: {
            applicationGroupList: [],
            selectApplicationList: [],
        },
    },
    isLoading: true,
    isChangedLang: false,
    companyLogo: '',
};

export default {
    state,
    actions,
    getters,
    mutations,
};
